import {
  CUSTOMER_LOYALTY_LIST_REQUESTING,
  LIST_CUSTOMER_LOYALTY_SUCCESS,
  RESET_CUSTOMER_LOYALTY_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isListFetching: false,
  query: null,
  recordCount: null,
  startingBalance: null,
  endingBalance: null
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_CUSTOMER_LOYALTY_ISFETCHING: {
      return {
        ...state,
        isListFetching: false
      };
    }
    case CUSTOMER_LOYALTY_LIST_REQUESTING: {
      return {
        ...state,
        isListFetching: true
      };
    }
    case LIST_CUSTOMER_LOYALTY_SUCCESS: {
      const data = { ...state.data };
      const query = [];
      action.payload.data.forEach((object) => {
        data[object.id] = object;
        query.push(object.id);
      });
      return {
        ...state,
        startingBalance: action.payload.startingBalance,
        endingBalance: action.payload.endingBalance,
        data,
        query,
        recordCount: action.payload.total,
        isListFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;
